export default "__VITE_ASSET__PMPiw2Wp__"